export default {

  eventCustomers: ((state, getters, rootState) => (eventId) => {
    return Object.values(rootState.entities.customers).filter(item => {
      return item.event == eventId;
    });
  }),

  activeCustomersIds: (state) => { return state.activeCustomersIds },

  contactDetails: ((state, getters, rootState) => (customerId, bucket = 'entities') => {
    if (!rootState[bucket].customers[customerId]) {
      return [];
    }

    return Object.values(rootState[bucket].contactDetails).filter(item => {
      return item.customer === customerId;
    })
  }),

};